<template>
    <div id="release-of-information-submission">
        <v-card flat>
            <v-card-text>
                <v-alert :color="successColor" icon="mdi-text-box-check-outline" prominent text>
                    The Release of Information has been successfully submitted. If there are any questions, please
                    contact
                    the Residence and Campus Life office.
                </v-alert>
            </v-card-text>
        </v-card>
        <v-footer padless="true">
            <v-container fluid>
                <v-row>
                    <v-col cols="12" md="10">
                        <v-card flat>
                            <v-card-text>
                                Should you have any questions or concerns about your application, please contact the
                                <b>King's
                                    Residence Office</b> by e-mail at <a
                                    href="mailto:residence@kings.uwo.ca">residence@kings.uwo.ca</a> or by telephone at
                                <b>1-800-265-4406 x4700</b>.
                            </v-card-text>
                            <v-card-text>
                                While every attempt has been made to create a user-friendly site, which is accessible
                                and
                                contains
                                current information, we may have missed something! If so, please contact us and we would
                                be
                                pleased
                                to make any necessary improvements.
                            </v-card-text>
                            <v-card-text class="font-weight-medium">
                                King's University College<br>
                                at The University of Western Ontario<br>
                                266 Epworth Avenue, London, Ontario, N6A 2M3 • Tel: (519) 433-3491
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-card flat>
                            <v-card-text>
                                <v-img src="../../../assets/backgrounds/kings_logo.jpg"></v-img>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-footer>
    </div>
</template>

<script>
export default {
    name: 'release-of-information-submission',
    methods: {
        setStep(val) {
            this.$emit('setStep', val);
        }
    },
    computed: {
        kingsGrey() {
            return '#6d6e71';
        },
        successColor() {
            return '#1bc5bd';
        }
    }
}
</script>

<style scoped>
.v-footer {
    background: #fff;
    border-top: 1px solid #0e0e0e;
}
</style>